import epxAvatar from "@/assets/images/site/epx.png";
import cpacAvatar from "@/assets/images/site/cpac.png";

export default {
  timelines: [
    // Timeline by group with title and details
    {
      icon: "fa fa-flask",
      title: "WORK HIGHLIGHTS",
      details: [
        {
          year: "Present",
          classname: "current",
          description:
            "My company builds websites, apps, and some other creative technology products for both consumers and organisations.  I also offer contract software development services for more specific requirements",
          position: "Developer-at-Large",
          subtitle: "PROTONMUFFIN™"
        },
        {
          year: "2020",
          description:
            "My role was to focus on building microservice APIs using Laravel to replace functionality in the current system, as well as building future ready new features as the company moves toward a modern SOA.  In my tenure I re-wrote microservice APIs, wrote a search API with Algolia and later TNTSearch engine integrations, integrated social logins a third-party referral service into the Auth API",
          position: "Senior Full-Stack Engineer",
          subtitle: "SIMPLESTREAM"
        },
        {
          year: "2019",
          description:
            "I worked with Sony Interactive Entertainment Europe (better known by literally everyone as the above) on their MarTec team. Working on a mixture of internal and customer/player facing projects.  A cool place to work with some cool people in it",
          position: "Senior Full-Stack Engineer (Contract)",
          subtitle: "SONY PLAYSTATION"
        },
        {
          year: "2018",
          description:
            "I was brought in to build out the company's prototype content delivery mechanism into a self-service automated Content Delivery System. Once that was done, they asked me to hang around for a bit longer and help them build their next generation survey system. So I did, and it was awesome. I ran 2 external dev teams in parallel as we ran multiple deployments of one system while we built another. Exciting times!",
          position: "Full-Stack Engineer (Contract)",
          subtitle: "MESHH"
        },
        {
          year: "2016",
          description:
            "I worked as a core developer building large parts of both back and frontends of the company’s flagship product, a mobile-first ticketing platform. I also worked on some standalone instances with bespoke apps. This included a corporate ticketing app for Ipswich Town Football Club, a VIP access app for the Sahara Force India Formula One Team, and ticketing for a series of Intel sponsored live music events.",
          position: "Full-Stack Engineer",
          subtitle: "ACTIVE TICKETING"
        },
        {
          year: "2016",
          description:
            "I did some work for these lovely folks, helping them to complete the backend of a conference web application they were building for Hewlett Packard Enterprise.",
          position: "Contract Developer",
          subtitle: "IVORY WORLDWIDE"
        },
        {
          year: "2015",
          description:
            "I was initially brought in to extend the LSH E-commerce website by adding templates for individual product pages, so that their product information could be dynamically ingested from an intermediate external database. But ended up working with them a bit longer to retrofit bootstrap into their existing website design, a new shopping cart, a new hire form, and a number of other improvements.",
          position: "Contract Developer",
          subtitle: "LONDON SPEAKER HIRE"
        },
        {
          year: "2011",
          description:
            "I had responsibility for the development, extension, and maintenance of client websites, web services, CLM systems, and a number of iPad apps using Titanium. Working with brands including GE Healthcare, Bayer AG, and ChloraPrep.",
          position: "Web and Mobile App Developer",
          subtitle: "SEVEN STONES"
        },
        {
          year: "2009",
          description:
            "I worked in a 2 person team responsible for the scoping and build of all web projects. A number of the projects worked on were for high visibility clients including HMRC, Virgin Media, and DEFRA.",
          position: "Web Developer",
          subtitle: "NOVARISING"
        },
        {
          year: "2008",
          description:
            "I was responsible for the end-to-end build of client websites along with some customer-facing and back-office roles.",
          position: "Web Developer",
          subtitle: "EPX TECHNICAL SERVICES"
        }
      ]
    },
    {
      icon: "icon-college",
      title: "EDUCATION HIGHLIGHTS",
      details: [
        {
          year: "2008",
          description:
            "Encompassed mobile technologies used in both devices and infrastructure. It also covered fundamental techniques used in developing software to run on mobile platforms.",
          position: "BSc (Hons) Mobile Computing and Mobile Communications",
          subtitle: "STAFFORDSHIRE UNIVERSITY"
        },
        {
          year: "2004",
          position: "BTEC National Diploma in Electronic Engineering",
          subtitle: "BROMLEY COLLEGE OF FURTHER AND HIGHER EDUCATION",
          hidden: true
        },
        {
          year: "2002",
          position: "City and Guilds Level II Diploma in Programming",
          subtitle: "GREENWICH TRAINING CO LTD",
          hidden: true
        },
        {
          year: "2000",
          position:
            "City and Guilds Level II Diploma in Electronic and Computer Systems",
          subtitle: "GREENWICH TRAINING CO LTD",
          hidden: true
        },
        {
          year: "1999",
          position: "GNVQ Engineering",
          subtitle: "WOOLWICH COLLEGE",
          hidden: true
        }
      ]
    }
  ],
  skills:
  //   Skills by group with main title and details
    {
      title: "XP",
      icon: "fas fa-sliders-h",
      details: [
        {
          language: "PHP",
          bar: 90
        },
        {
          language: "HTML/CSS/JS/JQUERY",
          bar: 95
        },
        {
          language: "LARAVEL",
          bar: 80
        },
        {
          language: "ANGULARJS",
          bar: 70
        },
        {
          language: "IONIC 1",
          bar: 68
        },
        {
          language: "VUE.JS",
          bar: 40
        },
        {
          language: "REACT",
          bar: 10
        }
      ]
    },
  testimonials: {
    title: "NICE STUFF PEOPLE HAVE SAID ABOUT ME",
    icon: "icon-comment",
    details: [
      {
        image: epxAvatar,
        name: "Daniel Ellis",
        post: "MANAGING DIRECTOR / EPX TECHNICAL SERVICES",
        testimonial:
          "I’ve known Mr Buckman for over 10 years now. During his time at EPX he was an excellent employee and had a dedication & loyalty that has been difficult to match in the years since. I find his infectious enthusiasm something highly encouraging.  He is passionate about his work and is always keeping me up to date with technology news.  Anyone would be lucky to work with him."
      },
      {
        name: "Jon Hodges",
        post: "DIGITAL DIRECTOR / IVORY WORLDWIDE",
        testimonial:
          "A very friendly developer who works hard to get the job done."
      },
      {
        image: cpacAvatar,
        name: "Shifu Shi Heng Sheng",
        post: "35TH GENERATION SHAOLIN MASTER / CHINESE PERFORMING ARTS CENTRE",
        testimonial: "Yes, your Kung-Fu still good"
      }
    ]
  },
  // // resume detail
  // resume: {
  //   title: "DOWNLOAD MY CV",
  //   link: "www.google.com",
  //   icon: "icon-doc-alt",
  //   button: "Download CV",
  //   description:
  //     "He is a great and hardworking guy. I am so proud of i have him as my asistant. He helped me so much. Also he is a great and hardworking guy. I am so proud of i have him as my asistant. He helped me so much."
  // },
  //   portfolio link
  profile: {
    title: "VIEW MY LINKEDIN PROFILE",
    icon: "icon-linkedin",
    link: "https://www.linkedin.com/in/nikbuckman",
    button: {
      href: "#",
      icon: "fas fa-external-link-alt",
      title: "View Profile",
      btnClasses: "brand linkedin button-icon big"
    },
    description:
      "You can view my LinkedIn profile if you like. It’s just Facebook for adults anyway."
  }
};
